"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LavaTubeSettlement = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const LavaFlows_1 = require("../base/LavaFlows");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const BoardName_1 = require("../../boards/BoardName");
const PlaceCityTile_1 = require("../../deferredActions/PlaceCityTile");
const CardRenderer_1 = require("../render/CardRenderer");
const Units_1 = require("../../Units");
class LavaTubeSettlement extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.LAVA_TUBE_SETTLEMENT,
            tags: [Tags_1.Tags.BUILDING, Tags_1.Tags.CITY],
            cost: 15,
            productionBox: Units_1.Units.of({ energy: -1, megacredits: 2 }),
            metadata: {
                cardNumber: 'P37',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => {
                        pb.minus().energy(1).br;
                        pb.plus().megacredits(2);
                    }).br;
                    b.city().asterix();
                }),
                description: 'Decrease your Energy production 1 step and increase your M€ production 2 steps. Place a City Tile on a VOLCANIC AREA regardless of adjacent cities.',
            },
        });
    }
    getSpacesForCity(player) {
        const boardName = player.game.gameOptions.boardName;
        if (boardName === BoardName_1.BoardName.HELLAS || boardName === BoardName_1.BoardName.ARABIA_TERRA) {
            return player.game.board.getAvailableSpacesForCity(player);
        }
        return LavaFlows_1.LavaFlows.getVolcanicSpaces(player);
    }
    canPlay(player) {
        return this.getSpacesForCity(player).length > 0 && player.getProduction(Resources_1.Resources.ENERGY) >= 1;
    }
    play(player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        player.addProduction(Resources_1.Resources.ENERGY, -1);
        player.game.defer(new PlaceCityTile_1.PlaceCityTile(player, 'Select a volcanic area to place this tile on', this.getSpacesForCity(player)));
        return undefined;
    }
}
exports.LavaTubeSettlement = LavaTubeSettlement;
//# sourceMappingURL=LavaTubeSettlement.js.map